
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstatationtaxiservice() {



  const cardData =
  {
    keyword: 'Outstation Taxi Service in Pune',
    heading: 'AB Ghule Cabs: Outstation Taxi Service in Pune',
    headingDescription: 'Looking for a reliable outstation taxi service in Pune? AB Ghule Cabs offers comfortable, affordable, and safe cab services for all your outstation travel needs. Whether you are heading for a weekend getaway, business trip, or a pilgrimage, we provide well-maintained vehicles, professional drivers, and a hassle-free travel experience. Book your outstation taxi from Pune and enjoy a smooth and scenic journey to your destination.',

    top: 'Outstation Destinations Covered by AB Ghule Cabs',

    topPlaces: [
        {
            title: "Mumbai",
            description: "Whether you're traveling for business or leisure, our cabs offer a comfortable ride from Pune to Mumbai. Explore the vibrant city of Mumbai, known for its iconic landmarks, shopping, and entertainment."
        },
        {
            title: "Shirdi",
            description: "Experience a peaceful and spiritual journey to Shirdi, the abode of Sai Baba. AB Ghule Cabs offers convenient and reliable services to make your pilgrimage smooth and comfortable."
        },
        {
            title: "Mahabaleshwar",
            description: "Head to the beautiful hill station of Mahabaleshwar with AB Ghule Cabs. Known for its stunning views, pleasant weather, and strawberry farms, Mahabaleshwar is an ideal destination for nature lovers."
        },
        {
            title: "Lonavala",
            description: "Enjoy a scenic drive to Lonavala, a popular hill station located between Pune and Mumbai. Known for its picturesque landscapes, lush greenery, and historic forts, Lonavala is perfect for a weekend getaway."
        },
        {
            title: "Goa",
            description: "Take a relaxing ride to the beaches of Goa with AB Ghule Cabs. Known for its vibrant nightlife, stunning beaches, and Portuguese architecture, Goa is a perfect destination for fun and relaxation."
        },
        {
            title: "Aurangabad",
            description: "Visit the historical city of Aurangabad, home to famous attractions like the Ajanta and Ellora Caves, Bibi Ka Maqbara, and the historic Daulatabad Fort. AB Ghule Cabs ensures a comfortable ride to this cultural hub."
        },
        {
            title: "Nashik",
            description: "Known for its vineyards, temples, and the Nashik Kumbh Mela, Nashik is an ideal destination for both spiritual and leisure travelers. Let AB Ghule Cabs take you on a memorable journey to Nashik."
        },
        {
            title: "Kolhapur",
            description: "Travel to Kolhapur, famous for its temples, including the Mahalaxmi Temple, and its rich cultural heritage. AB Ghule Cabs ensures your journey to Kolhapur is safe and comfortable."
        },
        {
            title: "Surat",
            description: "Head to Surat, a major diamond and textile hub of India. Known for its bustling markets and rich history, Surat is perfect for a business trip or sightseeing."
        },
        {
            title: "Alibaug",
            description: "For a coastal escape, AB Ghule Cabs offers services to Alibaug, a beautiful beach destination near Mumbai. Alibaug is known for its sandy beaches, forts, and serene surroundings, perfect for a relaxing weekend."
        }
    ],


    services: [
        {
          "name": "Outstation Taxi Service Pune",
          description: "AB Ghule Cabs offers reliable outstation taxi services from Pune. Whether it's a weekend getaway or a business trip, our well-maintained vehicles and experienced drivers ensure a safe and comfortable journey."
        },
        {
          "name": "Outstation Cabs Pune",
          description: "Book your outstation cabs from Pune with AB Ghule Cabs. We provide a variety of vehicle options, from sedans to SUVs, ensuring a comfortable and affordable ride for your long-distance trips."
        },
        {
          "name": "One Way Cab Pune",
          description: "AB Ghule Cabs offers one-way cab services from Pune to various destinations. Our one-way taxi services are affordable and hassle-free, designed to give you a smooth journey with no return charges."
        },
        {
          "name": "Best Outstation Cab Service in Pune",
          description: "For the best outstation cab service in Pune, choose AB Ghule Cabs. We offer top-notch services with reliable drivers, well-maintained vehicles, and competitive pricing, ensuring your journey is smooth and enjoyable."
        },
        {
          "name": "Outstation Cab Service in Pune",
          description: "AB Ghule Cabs provides affordable and reliable outstation cab services in Pune. Our fleet of vehicles includes sedans, SUVs, and more, making your outstation trip comfortable and convenient."
        },
        {
          "name": "Outstation Car Rental Pune",
          description: "Rent a car for your outstation journey from Pune with AB Ghule Cabs. We offer well-maintained cars like sedans, SUVs, and more, available at competitive prices for your comfort and convenience."
        },
        {
          "name": "Taxi in Pune for Outstation",
          description: "Looking for a taxi in Pune for outstation travel? AB Ghule Cabs provides reliable and comfortable taxis for your outstation trips, with experienced drivers ensuring a safe and smooth ride."
        },
        {
          "name": "Cab Booking in Pune for Outstation",
          description: "Book your outstation cab in Pune with AB Ghule Cabs. We offer easy online booking options for a seamless travel experience, whether you're traveling solo, with family, or in a group."
        },
        {
          "name": "Book Outstation Cabs Pune",
          description: "Book your outstation cabs from Pune with AB Ghule Cabs. Our services include various vehicle options, ensuring that your long-distance journey is comfortable, safe, and affordable."
        },
        {
          "name": "Taxi Service in Pune for Outstation",
          description: "AB Ghule Cabs offers dependable taxi services for outstation travel from Pune. Whether you're traveling to a nearby city or further afield, our experienced drivers and comfortable vehicles ensure a pleasant journey."
        },
        {
          "name": "Intercity Cab Service in Pune",
          description: "Travel between cities with AB Ghule Cabs' intercity cab services. Our well-maintained cars and professional drivers ensure a smooth and timely ride from Pune to nearby cities and beyond."
        },
        {
          "name": "Outstation Taxi Service in Pune",
          description: "AB Ghule Cabs provides reliable outstation taxi services in Pune. Our fleet of vehicles is equipped to handle long-distance travel, ensuring comfort, safety, and punctuality on your outstation trips."
        },
        {
          "name": "Outstation Taxi in Pune",
          description: "Looking for an outstation taxi in Pune? AB Ghule Cabs offers affordable and reliable taxi services, ensuring you travel in comfort and safety on your outstation trips."
        },
        {
          "name": "Pune Airport to Kolhapur Cab",
          description: "Book a cab from Pune Airport to Kolhapur with AB Ghule Cabs. We offer prompt and reliable taxi services to Kolhapur, ensuring a smooth ride with experienced drivers and comfortable vehicles."
        },
        {
          "name": "Pune to Outstation Taxi",
          description: "For a comfortable and reliable taxi from Pune to outstation destinations, AB Ghule Cabs is the perfect choice. We offer affordable pricing, well-maintained vehicles, and professional drivers for a smooth journey."
        },
        {
          "name": "Innova Crysta on Rent in Pune",
          description: "Rent an Innova Crysta in Pune for your outstation trips with AB Ghule Cabs. Our well-maintained Innova Crysta vehicles provide luxury and comfort for your long-distance travels."
        },
        {
          "name": "Tempo Traveller on Rent for Outstation",
          description: "AB Ghule Cabs offers Tempo Traveller rentals for outstation trips from Pune. Ideal for group travel, our Tempo Travellers ensure comfort and convenience for all passengers, whether it's for a short trip or a long journey."
        },
        {
          "name": "Ertiga on Rent in Pune for Outstation",
          description: "Rent an Ertiga for your outstation trip from Pune with AB Ghule Cabs. Our Ertiga vehicles are spacious, comfortable, and perfect for family trips or small group travel to nearby destinations."
        },
        {
          "name": "Pune to Outstation Sedan Cab Service",
          description: "AB Ghule Cabs offers sedan cab services for outstation trips from Pune. Our well-maintained sedans provide comfort, reliability, and affordability for your journey to various destinations."
        },
        {
          "name": "Pune to Outstation Swift Cab Service",
          description: "For an affordable and comfortable journey from Pune to outstation destinations, book a Swift cab with AB Ghule Cabs. Our Swift cabs are well-maintained, ensuring a smooth ride for your outstation trips."
        },
        {
          "name": "Outstation Taxi Service Pune Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Outstation Taxi Service Pune. We ensure a smooth and enjoyable ride for all our customers."
        }
      ],

      tableData : [
        ["- Outstation taxi service Pune", "- Outstation cabs Pune"],
        ["- One way cab Pune", "- Best outstation cab service in pune"],
        ["- Outstation cab service in pune", "- Outstation car rental Pune"],
        ["- Taxi in pune for outstation", "- Cab booking in pune for outstation"],
        ["- Book Outstation cabs Pune", "- Taxi service in pune for outstation"],
        ["- Intercity cab service in pune", "- Outstation taxi service in pune"],
        ["- Outstation taxi in pune", "- Pune airport to kolhapur cab"],
        ["- Pune to outstation taxi", "- Innova Crysta On Rent In Pune"],
        ["- Tempo traveller on rent for outstation", "- Ertiga on rent in pune for outstation"],
        ["- Pune to outstation sedan cab service", "- Pune to outstation swift cab service"],
      ],
      
      whychoose : [
        {
          WhyChooseheading: "Reliable and Professional Service",
          WhyChoosedescription: "AB Ghule Cabs offers dependable and professional outstation taxi services in Pune. Whether you're traveling for business, leisure, or any other reason, our expert drivers ensure you have a smooth, comfortable, and safe journey to your outstation destination."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "We are available round-the-clock to accommodate your outstation travel plans. Whether it’s an early morning departure or a late-night ride, we are always ready to provide reliable taxi services for your outstation trips from Pune."
        },
        {
          WhyChooseheading: "Affordable Rates",
          WhyChoosedescription: "Our pricing is competitive and transparent with no hidden charges. We offer affordable outstation taxi services with flexible pricing options, ensuring that you get the best value for your money, whether you’re traveling solo or with a group."
        },
        {
          WhyChooseheading: "Clean and Well-Maintained Fleet",
          WhyChoosedescription: "Our fleet includes well-maintained, clean vehicles equipped for long journeys. From budget sedans to more luxurious vehicles, we offer a range of options to suit your preferences and group size, ensuring a comfortable and hassle-free ride."
        },
        {
          WhyChooseheading: "Safe and Comfortable Rides",
          WhyChoosedescription: "Your safety is our top priority. Our drivers are highly experienced and background-checked, and our vehicles are equipped with modern safety features, including GPS, to ensure you have a secure and smooth journey to your outstation destination."
        },
        {
          WhyChooseheading: "Easy Booking Process",
          WhyChoosedescription: "Booking an outstation taxi with AB Ghule Cabs is simple and hassle-free. You can book your ride through our website, mobile app, or by calling our customer service team for quick assistance."
        },
        {
          WhyChooseheading: "Customer Satisfaction",
          WhyChoosedescription: "With many positive reviews and loyal customers, we take pride in providing excellent customer service. We are committed to ensuring your outstation travel experience is seamless, enjoyable, and stress-free."
        }
      ]
      
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book an outstation taxi with AB Ghule Cabs?',
      answer: 'You can easily book an outstation taxi through our website, mobile app, or by calling our customer service team, who will assist you with your booking.',
    },
    {
      id: 'FAQ2',
      question: 'Are your drivers experienced and trustworthy?',
      answer: 'Yes, all of our drivers are experienced, professional, and background-checked to ensure a safe and pleasant journey for you.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for booking?',
      answer: 'We offer a variety of vehicles, including sedans, SUVs, and luxury cars, so you can choose the vehicle that best fits your travel needs for your outstation journey.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my ride?',
      answer: 'We offer several payment options, including cash, credit/debit cards, and online payments through our mobile app. You can select the method that is most convenient for you.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'There may be additional charges for waiting time or detours, but we ensure full transparency. Any extra charges will be communicated to you before the trip starts.',
    },
    {
      id: 'FAQ6',
      question: 'Can I cancel or modify my booking?',
      answer: 'Yes, you can modify or cancel your booking easily via our website or mobile app. Our customer service team is also available to assist with any changes or cancellations.',
    },
    {
      id: 'FAQ7',
      question: 'Do you offer one-way and round-trip services for outstation trips?',
      answer: 'Yes, we offer both one-way and round-trip outstation taxi services, giving you flexibility depending on your travel requirements.',
    },
    {
      id: 'FAQ8',
      question: 'Is AB Ghule Cabs available for group travel?',
      answer: 'Yes, we offer spacious vehicles for group travel. Whether it’s for family trips, corporate outings, or with friends, we ensure a comfortable journey for your group.',
    },
    {
      id: 'FAQ9',
      question: 'What makes AB Ghule Cabs different from other outstation taxi services?',
      answer: 'AB Ghule Cabs is known for its professionalism, commitment to customer satisfaction, affordable rates, well-maintained fleet, and experienced drivers. We prioritize your comfort, safety, and timely service on every trip.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Rakesh Patel",
      feedback: "I traveled from Pune to Nashik with AB Ghule Cabs, and it was a smooth and comfortable ride. The driver was professional and friendly, and the car was clean and well-maintained. I will definitely use their services for future outstation trips.",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Anjali Deshmukh",
      feedback: "I had a wonderful experience with AB Ghule Cabs during my outstation trip to Lonavala. The booking process was quick, the driver was punctual, and the vehicle was spacious and clean. Highly recommended for outstation journeys!",
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Outstation Taxi Service Pune | Book Outstation Cabs</title>
  <meta name="description" content="Book outstation taxi service in Pune with AB Ghule Cabs. Offering one-way, round-trip, and intercity cab services, including Innova, Tempo Traveller, and more. Call +91 8624029699 for booking." />
  <meta name="keywords" content="Outstation taxi service Pune, Outstation cabs Pune, One way cab Pune, Best outstation cab service in Pune, Outstation cab service in Pune, Outstation car rental Pune, Taxi in Pune for outstation, Cab booking in Pune for outstation, Book outstation cabs Pune, Taxi service in Pune for outstation, Intercity cab service in Pune, Outstation taxi service in Pune, Outstation taxi in Pune, Pune airport to Kolhapur cab, Pune to outstation taxi, Innova Crysta on rent in Pune, Tempo Traveller on rent for outstation, Ertiga on rent in Pune for outstation, Pune to outstation sedan cab service, Pune to outstation Swift cab service" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Outstation Taxi Service Pune | Book Outstation Cabs" />
  <meta property="og:description" content="Book outstation taxi service in Pune with AB Ghule Cabs. Offering one-way, round-trip, and intercity cab services, including Innova, Tempo Traveller, and more. Call +91 8624029699 for booking." />
  <meta property="og:image" content="https://abghulecabs.com/images/outstation-taxi-service-pune.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/outstation-taxi-service-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "TaxiService",
        "name": "AB Ghule Cabs - Outstation Taxi Service Pune",
        description: "Book outstation taxi service in Pune with AB Ghule Cabs. Offering one-way, round-trip, and intercity cab services, including Innova, Tempo Traveller, and more. Call +91 8624029699 for booking.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/outstation-taxi-service-pune",
        "logo": "https://abghulecabs.com/images/outstation-taxi-service-pune.jpg",
        "image": "https://abghulecabs.com/images/outstation-taxi-service-pune.jpg",
        "priceRange": "₹1500 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/outstation-taxi-service-pune",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "180"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh P"
            },
            "datePublished": "2024-10-15",
            "reviewBody": "The outstation taxi service was fantastic. The driver was courteous, and the car was in great condition. Highly recommended for long-distance travel!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Meera T"
            },
            "datePublished": "2024-07-25",
            "reviewBody": "I used the outstation service from Pune to Kolhapur. The booking was smooth, and the cab was very comfortable. Will definitely use again!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and surrounding outstation locations",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/outstation-taxi-service-pune"
        },
        "keywords": "Outstation taxi service Pune, Outstation cabs Pune, One way cab Pune, Best outstation cab service in Pune, Outstation cab service in Pune, Outstation car rental Pune, Taxi in Pune for outstation, Cab booking in Pune for outstation, Book outstation cabs Pune, Taxi service in Pune for outstation, Intercity cab service in Pune, Outstation taxi service in Pune, Outstation taxi in Pune, Pune airport to Kolhapur cab, Pune to outstation taxi, Innova Crysta on rent in Pune, Tempo Traveller on rent for outstation, Ertiga on rent in Pune for outstation, Pune to outstation sedan cab service, Pune to outstation Swift cab service"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/64.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Outstatationtaxiservice;